/* eslint-disable no-param-reassign */
import React, { useContext, useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';

import * as actions from '../actions';

function GeneratePermit({
  id,
  sanitaryPermit,
  businessPermit,
  formData,
  setFormData,
  generatePermit,
  getItem,
}) {
  const setModal = useContext(ModalContext);
  useEffect(() => {
    setFormData({
      generate_sanitary_permit: 0,
      generate_business_permit: 0 
    })
  }, [])

  const closeModal = e => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    generatePermit(id, formData, () => {
      setModal({ isOpen: false });
      getItem(id);
    });
  };

  const onChange = e => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.checked ? 1 : 0,
    });
  };

  return (
    <Modal.Body>
      <form onSubmit={handleSubmit} className="pt-2">
        <div className="row pl-3">
          <label className="p-3">Generate the following Permits?</label>
          {!sanitaryPermit && (
            <div className="col-12 form-group">
              <input
                name="generate_sanitary_permit"
                type="checkbox"
                checked={_.get(formData, 'generate_sanitary_permit')}
                onChange={onChange}
              />
              <label htmlFor="last_name" className="form-label">
                &nbsp; Sanitary Permit
              </label>
            </div>
          )}
          {!businessPermit && (
            <div className="col-12 form-group">
              <input
                name="generate_business_permit"
                type="checkbox"
                checked={_.get(formData, 'generate_business_permit')}
                onChange={onChange}
              />
              <label htmlFor="last_name" className="form-label">
                &nbsp; Business Permit
              </label>
            </div>
          )}
        </div>
        <hr />
        <div className="row d-flex justify-content-center pt-2">
          <div>
            <button type="button" onClick={closeModal} className="btn btn-dark mr-1">
              Cancel
            </button>
            <button
              type="submit"
              className="btn btn-primary cms-bg-color-primary cms-outline-primary mr-1"
              disabled={_.get(formData, 'generate_sanitary_permit') === 0 &&  _.get(formData, 'generate_business_permit') === 0}
            >
              Generate
            </button>
          </div>
        </div>
      </form>
    </Modal.Body>
  );
}

GeneratePermit.propTypes = {
  getItem: PropTypes.instanceOf(Function).isRequired,
  generatePermit: PropTypes.instanceOf(Function).isRequired,
  setFormData: PropTypes.instanceOf(Object).isRequired,
  formData: PropTypes.instanceOf(Function).isRequired,
  id: PropTypes.string.isRequired,
  sanitaryPermit: PropTypes.bool.isRequired,
  businessPermit: PropTypes.bool.isRequired,
};

const mapStateToProps = () => ({});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(GeneratePermit);
